import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

import { Logger } from '../logger.service';
import { AuthenticationService } from './authentication.service';

const log = new Logger('AuthenticationGuardPublic');

@Injectable()
export class AuthenticationGuardPublic implements CanActivate {

  constructor(private router: Router,
              private authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log('can activate public');
    if (!this.authenticationService.isAccredited()) {
      return true;
    }
    if (state.url.indexOf('accredited') !== -1) {
      return true;
    } else {
      this.router.navigate(['/accredited'], {replaceUrl: true});
      return false;
    }
  }

  isRouterAcessible(): boolean {
    return true;
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/authentication/authentication.guard.public.ts